import { useState, useEffect } from "react";
import axios from "axios";
import {
  Grid,
  Card,
  CardContent,
  Container,
  Box,
  CssBaseLine,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";
import "./Reviews.css";
import { CSVLink } from "react-csv";
import Moment from "moment";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
// import Pagination from "./Pagination";
import {BASE_API_URL as baseURL} from ".././Constant"

export default function Reviews() {
  const [feedbacksDataForDownload, setFeedbacksDataForDownload] = useState([]);
  const [page, setPage] = useState(1);
  const [reviews, setreviews] = useState([]);
  const [avgRating, setAvgRating] = useState(0);
  const itemsPerPage = 6;

  console.log(avgRating, "AVG RATING");
  const getFormattedData = (feedbackResponse) => {
    const updatedDownloadData = feedbackResponse.map((feedback, idx) => {
      return {
        "SL#": idx + 1,
        "Enterprise Id": feedback.enterprise_id,
        Rating: feedback.rating === 0 ? "" : feedback.rating,
        Comment: feedback.comment ? feedback.comment.trim() : "-",
        "Submitted Date": `${Moment(feedback.created_at).format("DD-MM-YYYY")}`,
      };
    });

    const totalRating = feedbackResponse.reduce(
      (sum, item) => (sum += item.rating),
      0
    );
    const averageRating =
      feedbacksDataForDownload.length > 0
        ? Math.floor(totalRating / feedbacksDataForDownload.length)
        : 0;
    setAvgRating(averageRating);

    return updatedDownloadData;
  };

  const fetchData = async () => {
    try {
      let response = await axios({
        method: "get",
        //url: `http://localhost:3041/feedback`,
        url: `${baseURL}/feedback`,

        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });
      // setFeedbacks(response.data.results);
      setreviews(response.data.results);
      setFeedbacksDataForDownload(getFormattedData(response.data.results));
      console.log(response.data);
      console.log(response.data.results.length, "data here");
      const totalRating = response.data.results.reduce(
        (sum, item) => (sum += item.rating),
        0
      );
      const averageRating =
        response.data.results.length > 0
          ? Math.floor(totalRating / response.data.results.length)
          : 0;
      setAvgRating(averageRating);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const handlepageChange = (e, pagenumber) => {
    console.log(pagenumber);
    setPage(pagenumber);
  };

  const indexOfLastItem = page * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reviews?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="main-container">
      <div className="banner-container">
        <div className="rating-container">
          <h1>Rating</h1>
          <p className="text-overlay">{avgRating}</p>
          <p className="text-overlay2">
            {[...Array(avgRating)].map((star) => {
              return (
                <img
                  src={process.env.PUBLIC_URL + "/images/feedback/big-star.png"}
                  alt="stars"
                  className="stars-banner"
                />
              );
            })}
            {[...Array(5 - avgRating)].map((star) => {
              return (
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/feedback/big-star-out.png"
                  }
                  alt="stars"
                  className="stars-banner"
                />
              );
            })}{" "}
          </p>
          <img
            src={process.env.PUBLIC_URL + "/images/feedback/ratings.png"}
            alt="Ratings"
            className="ratings"
          />
        </div>
        <div className="bannerimg-container">
          <img
            src={process.env.PUBLIC_URL + "/images/feedback/banner.png"}
            alt="Ratings Banner"
            className="banner"
          />
        </div>
      </div>
      <div className="download-container">
        <h2>Feedback</h2>
        <div className="down-btn">
          {/* <button className="download-btn">Download</button> */}
          {feedbacksDataForDownload.length === 0 ? (
            "No Records"
          ) : (
            <div className="download-btn">
              <img
                src={process.env.PUBLIC_URL + "/images/feedback/down.png"}
                alt="download"
                className="downloads"
              />
              <CSVLink
                filename={`feedbacks.csv`}
                data={feedbacksDataForDownload}
                // onClick={handleFeedbackDownload}
              >
                Download
              </CSVLink>
            </div>
          )}
        </div>
      </div>
      <div className="box-container">
        {feedbacksDataForDownload.length > 0 ? (
          currentItems.map((review) => {
            return (
              <div className="box">
                <div className="title1">
                  <p className="user-name">{review.enterprise_id}</p>
                  {[...Array(review.rating)].map((star) => {
                    return (
                      <img
                        src={
                          process.env.PUBLIC_URL + "/images/feedback/star.png"
                        }
                        alt="stars"
                        className="stars"
                      />
                    );
                  })}
                  {[...Array(5 - review.rating)].map((star) => {
                    return (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/feedback/outlined-star.png"
                        }
                        alt="stars"
                        className="stars"
                      />
                    );
                  })}
                  <p>{`${Moment(review.created_at).format("DD-MM-YYYY")}`}</p>
                </div>
                <p className="comment">{review.comment}</p>
              </div>
            );
          })
        ) : (
          <p className="validation">No Feedback Given yet!!</p>
        )}
      </div>
      <div className="pagin">
        {feedbacksDataForDownload.length > 6 && (
          <Pagination
            count={
              feedbacksDataForDownload.length > 0 &&
              Math.ceil(feedbacksDataForDownload.length / 6)
            }
            page={page}
            onChange={handlepageChange}
          />
        )}
      </div>
    </div>
  );
}
